import React, {Component} from 'react';
import {func, shape, string, oneOf} from 'prop-types';
import {mapObjIndexed, values, reject, isNil, pipe, splitEvery, map} from 'ramda';
import FilterSet, {filterListShape} from './FilterSet';
import onClickOutside from 'react-onclickoutside';
import styles from './FilterPanel.css';

const renderFilterRow = filters =>
  <div className={styles.filterSets}>{filters}</div>;

export class FilterPanel extends Component {
  renderFilter = (filter, key, filterObj) =>
    <FilterSet
      key={key}
      {...filter}
      onFilterChange={this.onFilterChange(filterObj, key)}
    />;

  render() {
    const {scope, packageType, status, field, constraint, generic, tag} = this.props;
    const filterOptions = {scope, packageType, status, field, constraint, generic, tag};

    const filters = pipe(
      reject(isNil),
      mapObjIndexed(this.renderFilter),
      values,
      splitEvery(4), // four filters per row
      map(renderFilterRow),
    )(filterOptions);

    return (
      <div className={styles.container}>
        <h4 className={styles.header}>Filters</h4>
        {filters}
      </div>
    );
  }

  onFilterChange = (filterOptions, filterType) => filters => {
    const newFilterOptions = {
      ...filterOptions,
      [filterType]: {
        ...filterOptions[filterType],
        filters,
      },
    };
    this.props.onFilterChange(newFilterOptions);
  };

  handleClickOutside() {
    this.props.onOutsideClick();
  }
}

export const optionShape = {
  groupName: string.isRequired,
  filterType: oneOf(['searchbar', 'checkbox', 'radio']).isRequired,
  filters: filterListShape.isRequired,
};

FilterPanel.propTypes = {
  onOutsideClick: func.isRequired,
  scope: shape(optionShape),
  packageType: shape(optionShape),
  field: shape(optionShape),
  status: shape(optionShape),
  constraint: shape(optionShape),
  generic: shape(optionShape),
  tag: shape(optionShape),
  onFilterChange: func.isRequired,
};

export default onClickOutside(FilterPanel);
